module.exports = __webpack_public_path__ + "img/teacher-pic002.1bea4b7b.jpg";